// extracted by mini-css-extract-plugin
export default {"cancelModalContent":"style_cancelModalContent__fSwz9","cancelModalButtons":"style_cancelModalButtons__HFGEw"};